export default {
  states: [{
    text: 'Activo',
    value: 1
  }, 
  {
    text: 'Resgate pontos',
    value: 4
  },
  {
    text: 'Inactivo',
    value: 3
  }],
  yesNo: [{
    text: 'Sim',
    value: 1
  }, {
    text: 'Não',
    value: 0
  }],
  dealerTypes: [
  {
    text: 'Concessionário',
    value: 1
  }, {
    text: 'Distribuidor',
    value: 2
  }],
  dsrTypes: [
  {
    text: 'Vendedor',
    value: 1
  }, {
    text: 'CV/Vendedor',
    value: 2
  }, {
    text: 'CV',
    value: 3
  }, {
    text: 'Gerente',
    value: 4
  }],
  dsrStates: [
  {
    text: 'Activo',
    value: 1
  }, {
    text: 'Não Participante',
    value: 2
  },{
    text: 'Resgate pontos',
    value: 4
  }, {
    text: 'Inactivo',
    value: 3
  }],
  formStates: [{
    text: 'Pendente',
    value: 0
  }, {
    text: 'Tratado',
    value: 1
  }, {
    text: 'Cancelado',
    value: 2
  }],
  formAlterationTypes: [{
    text: 'Inscrição',
    value: 1
  }, {
    text: 'Alterar',
    value: 2
  }, {
    text: 'Cancelar',
    value: 3
  }],
  months: [{
    text: 'Jan',
    value: 1
  }, {
    text: 'Fev',
    value: 2
  }, {
    text: 'Mar',
    value: 3
  }, {
    text: 'Abr',
    value: 4
  }, {
    text: 'Mai',
    value: 5
  }, {
    text: 'Jun',
    value: 6
  }, {
    text: 'Jul',
    value: 7
  }, {
    text: 'Ago',
    value: 8
  }, {
    text: 'Set',
    value: 9
  }, {
    text: 'Out',
    value: 10
  }, {
    text: 'Nov',
    value: 11
  }, {
    text: 'Dez',
    value: 12
  }],
  campaigns: [{
    text: 'Inativo',
    value: 0
  }, {
    text: 'Activo',
    value: 1
  }]
}
